import {
    Server
    // Response
} from 'miragejs';
import { API } from 'utils/constants';
import {
    busRelationshipCodesData,
    envPropsData,
    phoneTypeCodesData,
    securityQuestionsData,
    validatePinData,
    validateProfileData
    // errorResponseData,
} from './data';

export function mockServer({ environment = 'development' } = {}) {
    const server = new Server({
        environment,
        routes() {
            this.get(API.ENV_PROPS, () => {
                return envPropsData();
            });

            this.post(API.VALIDATE_PIN, () => {
                // return new Response(400, {}, errorResponseData());
                return validatePinData();
            });

            this.get(API.PHONE_CODES_ENDPOINT, () => {
                return phoneTypeCodesData();
            });

            this.get(API.BUS_REL_ENDPOINT, () => {
                return busRelationshipCodesData();
            });

            this.get(API.SECURITY_QUESTIONS, () => {
                return securityQuestionsData();
            });

            this.post(API.VALIDATE_PROFILE, () => {
                // return new Response(400, {}, errorResponseData());
                return validateProfileData();
            });

            this.get('https://lib-us-2.brilliantcollector.com/collector/switch/**', () => {
                return {};
            });

            this.post('https://lib-us-2.brilliantcollector.com/collector/collectorPost', () => {
                return {};
            });
        }
    });

    return server;
}
